module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxsiAiQ_a33snTsJhwZvMEaI.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/PRmiXeptR36kaC0GEAetxsiAiQ_a33snTsJhwZvMEaI.woff2
// module id = 419
// module chunks = 0